export const SET_USER = 'SET_USER';
export const SET_USER_CHANNEL = 'SET_USER_CHANNEL';
